<template>
	<div class="page-login">
		<div class="container" v-if="!showError">
			<div class="message-box text-center" v-if="!isResetPasswordVisible">
				<div class="message-box-icon flex-center mb-5">
					<div class="white-dot"></div>
				</div>
				<h3 class="mb-4">{{ $t('Performing something') }}</h3>
				<div class="text-lg mb-4">Please wait for a few seconds, we will redirect you to your dashboard</div>
			</div>
			<!-- Reset Password Form -->
			<div class="login-box card magic-link-box" v-else>
				<div class="login-box-content">
					<div class="login-error callout callout--danger hidden" v-if="loginError">
						<div class="callout__content">{{ loginError }}</div>
					</div>
						<div class="mb-3">
							<h2 class="font-weight-normal">{{ $t('Set Your Password') }}</h2>
						</div>
						<div class="text-small mb-3">
							{{ $t('Please set your account password to proceed') }}
						</div>
						<!-- New Password -->
						<div class="form-group">
							<div class="d-flex justify-content-between">
								<label>{{ $t('Your New Password') }}</label>
								<span class="font-small mt-1"
									:class="{'very-weak': warningError === 'Weak',
										'weak': warningError === 'Medium',
										'strong': warningError === 'Strong',
									}">
									{{warningError}}
								</span>
							</div>
							<input-password v-model="password" :required="false"/>
							<span class="text-danger text-small" v-if="warningError === 'Weak'">{{$t('Please enter a password of at least 8 characters, and use a combination of letters and numbers')}}</span>
						</div>
						<!-- Confirm New Password -->
						<div class="form-group mb-5">
							<div class="d-flex justify-content-between">
								<label>{{ $t('Confirm New Password') }}</label>
								<label class="text-danger text-small" v-if="confirmPassword && confirmPassword !== password">{{$t('Password do not match')}}</label>
							</div>
							<!-- <input type="password" name="confirm-new-password" class="form-control" v-model="confirmPassword" required> -->
							<input-password v-model="confirmPassword" />
						</div>
						<!-- Submit -->
						<button
							@click="resetPassword"
							type="submit"
							:disabled="!isFormValid"
							class="btn btn-submit btn-primary"
							:class="{ 'is-loading': isResetting }">
							{{ $t('SET MY PASSWORD') }}
						</button>
				</div>
			</div>
		</div>
			<div class="message-box text-center" v-if="showError">
				<div class="login-logo text-center mb-0">
					<img src="/img/logo/grafias_medium_ondark.png" class="d-inline-block m-auto" loading="lazy" alt="Grafias">
				</div>
				<img src="/img/OOPS.png" class="d-inline-block m-auto" loading="lazy" alt="Grafias">
				<span>
				<h3 class="mb-5 mt-4 text-center">{{ messageError }},
				<router-link
					to="/login"
					class="primary-text pb-1">
					{{ $t('click here to access grafiaslive.com') }}
				</router-link></h3>
			</span>
			</div>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import InputPassword from '@/components/InputPassword.vue';
import { TOKEN_KEY } from '@/lib/statics';
import { getAxiosErrorMessage } from '@/lib/helper';
import client from '@/lib/http-client';
import auth from '@/api/auth';

export default {
	name: 'AutoLogin',
	components: {
		InputPassword,
	},
	data() {
		return {
			isValidating: false,
			loginError: null,
			isResetPasswordVisible: false,
			password: '',
			confirmPassword: '',
			isResetting: false,
			messageError: '',
			showError: false,
			warningError: '',
		};
	},
	methods: {
		...mapActions({
			setLoggedIn: 'setLoggedIn',
			logout: 'logout',
		}),
		validateToken() {
			this.isValidating = true;
			const params = {
				token: this.token,
				lang: 'en',
			};
			const callback = (response) => {
				// const message = response.message;
				const jwt = response.data.token;
				const isSetPassword = response.data.is_set_password;
				localStorage.setItem(TOKEN_KEY, jwt);
				client.defaults.headers.Authorization = `Bearer ${jwt}`;
				if (!isSetPassword) {
					this.setLoggedIn();
					const routeData = this.$router.resolve('/');
					window.open(routeData.href, '_self');
				} else {
					this.isValidating = false;
					this.isResetPasswordVisible = true;
				}
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				// this.$notify({
				// 	group: 'app',
				// 	type: 'error',
				// 	title: 'Magic Link',
				// 	text: message,
				// });
				this.showError = true;
				this.messageError = message;
				this.isValidating = false;
			};
			auth.autoLogin(params, callback, errorCallback);
		},
		resetPassword() {
			this.isResetting = true;
			const params = {
				new_password: this.password,
				confirm_password: this.confirmPassword,
				lang: 'en',
			};
			const callback = (response) => {
				const message = response.message;
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Reset Password',
					text: message,
				});
				this.setLoggedIn();
				const routeData = this.$router.resolve('/');
				window.open(routeData.href, '_self');
				this.isResetPasswordVisible = false;
				this.isResetting = false;
			};
			const errorCallback = () => {
				this.isResetting = false;
			};
			// Change Password
			auth.changePassword(params, callback, errorCallback);
			// auth.resetPassword(this.email, this.token, params, callback, errorCallback);
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
		}),
		token() {
			const { token } = this.$route.query;
			return token;
		},
		email() {
			const { email } = this.$route.query;
			return email;
		},
		activeRouteName() {
			return this.$route.name;
		},
		isFormValid() {
			return (
				this.password === this.confirmPassword
				&& this.warningError !== 'Weak'
			);
		},
	},
	created() {
		this.validateToken();
	},
	watch: {
		password() {
			if (this.password !== '') {
				/* eslint-disable global-require */
				const passwordStrength = require('check-password-strength');
				if (this.password.length < 8) {
					this.warningError = 'Weak';
				} else {
					/* eslint-enable global-require */
					this.warningError = passwordStrength(this.password).value;
				}
			}
			if (this.password === '') this.warningError = '';
		},
	},
};
</script>
